import { Input, InputProps, InputRef } from "antd";
import React, { ReactElement, forwardRef } from "react";
export interface InputWithErrorBaseProp {
    isError: boolean;
    errorMsg?: string;
    onFocus?: () => void;
}

export type InputWithErrorProp = InputWithErrorBaseProp & InputProps;

export const InputWithError = forwardRef<InputRef, InputWithErrorProp>(
    ({ isError, errorMsg, onFocus, className, ...props }, ref): ReactElement => {
        const handleFocus = (): void => {
            onFocus?.();
        };

        return (
            <>
                <Input
                    ref={ref}
                    className={`modal-form-input ${className} ${isError && "modal-form-input-error"}`}
                    {...props}
                    onFocus={handleFocus}
                />
                {isError && errorMsg && <div className="modal-form-error">{errorMsg}</div>}
            </>
        );
    },
);

InputWithError.displayName = "InputWithError";
